<template>
    <div style="position: relative;">
        <video ref="video" autoplay muted playsinline style="width: 100%; background: black;" />
        <div v-if="loading" class="video-loading-overlay">
            <span class="spinner"></span>
            <span>カメラに接続していますので、しばらくお待ちください。</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        whepUrl: { type: String, required: false, default: '' },
        login: { type: String, required: true },
        password: { type: String, required: true },
    },
    data() {
        return {
            hasNotifiedError: false,
            loading: true,
        };
    },
    mounted() {
        if (!document.querySelector('script[src="/reader.js"]')) {
            this.scriptElement = document.createElement('script');
            this.scriptElement.src = '/reader.js';
            this.scriptElement.async = true;

            this.scriptElement.onload = this.initStream;
            this.scriptElement.onerror = () => {
                this.loading = false;
                this.error = 'Failed to load reader.js. Check the file path.';
            };

            document.head.appendChild(this.scriptElement);
        } else {
            this.initStream();
        }
    },
    beforeDestroy() {
        this.removeScript();
        if (this.reader) this.reader.close();
    },
    watch: {
        whepUrl() { this.initReader(); }
    },
    methods: {
        async initReader() {
            this.loading = true;
            if (!window.MediaMTXWebRTCReader || !this.whepUrl) return;
            if (this.reader) this.reader.close();
            this.hasNotifiedError = false;
            this.reader = new window.MediaMTXWebRTCReader({
                url: this.whepUrl,
                headers: {
                    Authorization: 'Basic ' + btoa(`${this.login}:${this.password}`)
                },
                onTrack: (evt) => {
                    this.$refs.video.srcObject = evt.streams[0];
                    this.loading = false;
                },
                onError: (err) => {
                    this.loading = false;
                    let msg = "";
                    if (err.status === 404) {
                        if (err.message.includes("no stream is available on path")) {
                            msg = "カメラが起動していないか、映像が取得できません";
                        } else {
                            msg = "通信がタイムアウトしました。ネットワーク状態を確認してください";
                        }
                    }
                    else if (err.status === 408 || err.status === 502 || err.message === "TypeError: Failed to fetch" || err.message === "peer connection closed") msg = "通信がタイムアウトしました。ネットワーク状態を確認してください";
                    else if (err.status === 401 || (err.status === 400 && err.message === "authentication failed: authentication failed")) msg = "映像の認証に失敗しました。ログイン情報をご確認ください";
                    else if (err.status === 400) msg = "同時接続数の上限に達しました。別の端末で視聴中の可能性あります。";
                    else msg = err.message

                    if (!this.hasNotifiedError) {
                        this.$vs.notify({
                            color: 'danger',
                            title: msg,
                        });
                        this.hasNotifiedError = true;
                    }
                    this.$emit('error', msg);
                }
            });

        },
        removeScript() {
            if (this.scriptElement) {
                document.head.removeChild(this.scriptElement);
                this.scriptElement = null;
            }
        }
    }
};
</script>
<style lang="scss">
.video-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    z-index: 10;
}

.spinner {
    border: 4px solid #2D9CDB;
    border-top: 4px solid #fff;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>